import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';

import { PgRendererComponent } from './components/pg-renderer/pg-renderer.component';
import { BlankComponent } from './blank.component';
import { StartScreenPendingComponent } from './components/tdp/start-screen/start-screen-pending.component';
import { StartScreenPinComponent } from './components/tdp/start-screen/start-screen-pin.component';
import { StartScreenAudioCheckComponent } from './components/tdp/start-screen/start-screen-audio-check.component';
import { StartScreenMicrophoneCheckComponent } from './components/tdp/start-screen/start-screen-microphone-check.component';
import { StartScreenStartCodeComponent } from './components/tdp/start-screen/start-screen-start-code.component';
import { StartScreenWebComponent } from './components/tdp/start-screen/start-screen-web.component';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

const appRoutes: Routes = [
  { path: '', component: BlankComponent },
  { path: 'start-screen/:station-number/pending', component: StartScreenPendingComponent },
  { path: 'start-screen/:station-number/pin', component: StartScreenPinComponent },
  { path: 'start-screen/:station-number/audio-check', component: StartScreenAudioCheckComponent },
  { path: 'start-screen/:station-number/microphone-check', component: StartScreenMicrophoneCheckComponent },
  { path: 'start-screen/:station-number/start-code', component: StartScreenStartCodeComponent },
  { path: 'testlet/:id', component: PgRendererComponent },
  { path: 'testlet/snapshot/:snapshot-id', component: PgRendererComponent },
  { path: 'testform/:test-form-id', component: PgRendererComponent },
  { path: 'testforms/:bulk-test-form-ids',component: PgRendererComponent },
  { path: 'testforms/:bulk-test-form-ids/:validate',component: PgRendererComponent },
  { path: 'testletversion/:testlet-version-id', component: PgRendererComponent },
  { path: 'assessment-test/:assessment-test-id', component: PgRendererComponent },
  { path: 'ipp-assessment-test/:ipp-assessment-test-id', component: PgRendererComponent },
  { path: 'ipp-assessment-test/latest/:ipp-assessment-test-id-for-latest', component: PgRendererComponent },
  { path: 'opt/:ipp-product-id', component: PgRendererComponent },
  { path: 'start-screen-web/:web-delivery-auth', component: StartScreenWebComponent },
];

export const appRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true });



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.routing.ts